export interface FeatureInfo {
    key: string;
    title: string;
    imgUrl: string;
    description: string;
}

export const PlatformFeatureKeys = {
    lists: 'lists',
    advancedSearch: 'advanced-search',
    vesselsSearch: 'vessels-search',
    vessels: 'vessels',
    vesselHeader: 'vessel-header',
    vesselSafetyScore: 'vessel-safety-score',
    vesselGhgRating: 'vessel-ghg-rating',
    vesselEnergySavingEquipment: 'vessel-energy-saving-equipment',
    vesselTabSafetyScore: 'vessel-tab-safety-score',
    vesselTabGhgRating: 'vessel-tab-ghg-rating',
    vesselTabOperationalMetrics: 'vessel-tab-operational-metrics',
    vesselTabDetails: 'vessel-tab-details',
    vesselTabActivities: 'vessel-tab-activities',
    vesselAllTabs: 'vessel-all-tabs',
    companyHeader: 'company-header',
    companyTabEnvironment: 'company-tab-environment',
    companyTabSocial: 'company-tab-social',
    companyTabGovernance: 'ccompany-tab-governance'
}

export const PlatformFeatures: FeatureInfo[] = [
    {
        key: PlatformFeatureKeys.lists,
        title: 'Lists & Alerts',
        imgUrl: require('../../images/freemium/navigation-lists-and-alerts.png'),
        description: `Upgrade to our premium subscription today to create your own list & alerts to keep track of vessels and companies that you are interested in. <br /> <br /> Don't miss out on this valuable information - upgrade to our premium subscription now and stay ahead of the competition!`
    },
    {
        key: PlatformFeatureKeys.advancedSearch,
        title: 'Unlock All Search Tools',
        imgUrl: require('../../images/freemium/advanced-search.png'),
        description: `Gain access to the Vessel and Company List with advanced filters to enhance your search experience`
    },
    {
        key:  PlatformFeatureKeys.vesselsSearch,
        title: 'Safety Score and GHG Rating',
        imgUrl: require('../../images/freemium/vessels-search.png'),
        description: `Upgrade to our premium subscription today and discover a world of vessel insights that will give you a competitive edge! Our premium subscribers gain exclusive access to comprehensive safety scores for every vessel on our platform, providing you with the knowledge to make informed decisions and reduce risk. <br /> <br />
            Additionally, you'll unlock the GHG ratings for every vessel, empowering you to make environmentally conscious choices that benefit both your business and the planet. <br /> <br />
            Don't miss out on this valuable information - upgrade to our premium subscription now and stay ahead of the competition!`
    },
    {
        key: PlatformFeatureKeys.vessels,
        title: 'Safety Score and GHG Rating',
        imgUrl: require('../../images/freemium/vessels-search.png'),
        description: `Upgrade to our premium subscription today and discover a world of vessel insights that will give you a competitive edge! Our premium subscribers gain exclusive access to comprehensive safety scores for every vessel on our platform, providing you with the knowledge to make informed decisions and reduce risk. <br /> <br />
            Additionally, you'll unlock the GHG ratings for every vessel, empowering you to make environmentally conscious choices that benefit both your business and the planet. <br /> <br />
            Don't miss out on this valuable information - upgrade to our premium subscription now and stay ahead of the competition!`
    },
    {
        key: PlatformFeatureKeys.vesselHeader,
        title: 'Unlock the full picture',
        imgUrl: require('../../images/freemium/vessel-header.png'),
        description: `Don't settle for incomplete data - unlock the full picture with our premium subscription and gain access to Safety Score, GHG Rating and RightShip Inspection validity for every vessel.`
    },
    {
        key: PlatformFeatureKeys.vesselSafetyScore,
        title: 'Upgrade to view Safety Scores',
        imgUrl: require('../../images/freemium/vessel-safety-score.png'),
        description: `Unlock the power of exclusive Safety Scores for 50,000 vessels on our platform.`
    },
    {
        key: PlatformFeatureKeys.vesselGhgRating,
        title: 'Upgrade to unlock GHG Rating',
        imgUrl: require('../../images/freemium/vessel-ghg-rating.png'),
        description: `Don't settle for incomplete GHG rating data! Upgrade to our premium subscription and gain access to comprehensive data on GHG ratings for 50,000 vessels on our platform.`
    },
    {
        key: PlatformFeatureKeys.vesselEnergySavingEquipment,
        title: 'Upgrade to view Energy saving equipment',
        imgUrl: require('../../images/freemium/vessel-energy-saving-equipment.png'),
        description: `Upgrade to our premium subscription and gain exclusive access to information on the latest energy-saving equipment used by the vessels in the shipping industry.`
    },
    {
        key: PlatformFeatureKeys.vesselTabSafetyScore,
        title: 'Safety Score',
        imgUrl: require('../../images/freemium/vessel-tab-safety-score.png'),
        description: `Don't settle for incomplete vessel safety data. Upgrade to our premium subscription and get the complete picture with our detailed safety scores. With this information, you can make informed decisions that reduce risk and protect your investments.`
    },
    {
        key: PlatformFeatureKeys.vesselTabGhgRating,
        title: 'GHG Rating',
        imgUrl: require('../../images/freemium/vessel-tab-ghg-rating.png'),
        description: `Upgrade to our premium subscription and gain a competitive edge in the shipping industry by unlocking exclusive GHG ratings, EVDI and EEDI, and peer group data for 50,000 vessels on our platform.`
    },
    {
        key: PlatformFeatureKeys.vesselTabOperationalMetrics,
        title: 'Operational Metrics',
        imgUrl: require('../../images/freemium/vessel-tab-operational-metrics.png'),
        description: `Gain a competitive edge in the shipping industry with our premium subscription. Unlock exclusive data on EEXI operational metrics for every vessel on our platform, and gain insights that will help you optimize performance and reduce environmental impact.`
    },
    {
        key: PlatformFeatureKeys.vesselTabDetails,
        title: 'Vessel Details',
        imgUrl: require('../../images/freemium/vessel-tab-details.png'),
        description: `Don't miss out on important vessel details! Upgrade to our premium subscription and gain access to the most comprehensive information on dimensions, capacity, and mechanical specifications for every vessel on our platform.`
    },
    {
        key: PlatformFeatureKeys.vesselTabActivities,
        title: 'Activity Timeline',
        imgUrl: require('../../images/freemium/vessel-tab-activities.png'),
        description: `Upgrade to our premium subscription and gain access to exclusive information on a vessel's activities timeline. With this data, you'll be able to track the history of every vessel on our platform, including important events that could impact performance and profitability. Don't miss out on this valuable resource!`
    },
    {
        key: PlatformFeatureKeys.vesselAllTabs,
        title: 'Access All Tabs',
        imgUrl: require('../../images/freemium/vessel-all-tabs.png'),
        description: `Don't settle for incomplete vessel safety data. Upgrade to our premium subscription and get the complete picture to make informed decisions when reviewing a vessel.`
    },
    {
        key: PlatformFeatureKeys.companyHeader,
        title: 'RightShip Management Audit',
        imgUrl: require('../../images/freemium/company-header.png'),
        description: `Get the inside scoop on DOC companies with our premium subscription - explore subscores and crew welfare status for every company on our platform. <br /> <br /> Don't settle for incomplete information about DOC companies - upgrade to our premium subscription and access comprehensive data that will help you stay ahead of the curve. With our detailed subscores and crew welfare status, you'll have a clear understanding of each company's performance and be able to make informed decisions about who to work with.`
    },
    {
        key: PlatformFeatureKeys.companyTabEnvironment,
        title: 'Environment Tab',
        imgUrl: require('../../images/freemium/company-tab-environment.png'),
        description: `Upgrade to our premium subscription and unlock exclusive access to our environment tab, featuring detailed information on vessel GHG verification status, EEDI vessel types, DOC Fleet GHG Rating and more.`
    },
    {
        key: PlatformFeatureKeys.companyTabSocial,
        title: 'Social Tab',
        imgUrl: require('../../images/freemium/company-tab-social.png'),
        description: `Upgrade to our premium subscription and gain exclusive access to information on crew welfare assessment status and abandonment verification for every vessel on our platform. With this valuable data, you'll be able to make informed decisions that prioritize the safety and well-being of crew.`
    },
    {
        key: PlatformFeatureKeys.companyTabGovernance,
        title: 'Governance Tab',
        imgUrl: require('../../images/freemium/company-tab-governance.png'),
        description: `Upgrade to our premium subscription and unlock exclusive access to our governance tab, featuring detailed information on DOC subscore, vessel compliance, and more.`
    } 
];